import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Row, Col, Button, Modal, ModalBody } from "reactstrap";
import { DatePicker, Popover, Tooltip, Modal as AntdModal, message, Radio, Space } from "antd";
import { EditOutlined, InfoCircleOutlined, SettingOutlined } from "@ant-design/icons";
import FormInput from "../../form-components/InputComponent";
import FormSelect from "../../form-components/SelectComponent";
import FormDatePicker from "../../form-components/DatePicker";
import sites from "../../../api/master/sites";
import costCenterApis from "../../../api/master/costCenter";
import FormTextArea from "../../form-components/TextAreaComponent";
import { useFormData } from "./FormDataContext";
import AskDocuments from "./AskDocuments";
import BudgetApprovalDrawer from "./BudgetApprovalDrawer";
import { SelectOptions, ApprovalData, DocumentFormValues } from "./types"; // Import your types
import { Icon } from "../../../components/Component";
import dayjs from "dayjs";
import budgetApis from "../../../api/master/budget";
import { useDispatch, useSelector } from "react-redux";
import { fetchSequenceAccess } from "../../../store/slices/misc/sequenceAccess";

import sequenceApis from "../../../api/master/sequence";
interface SequenceType {
  module: string;
  level: string;
  siteIds: string[];
}
const BudgetGeneralDetails: React.FC = (props: any) => {
  const [sequenceAccess, setSequenceAccess] = useState<any>(null);
  const [activeSequences, setActiveSequences] = useState<any[]>([]);
  const [numberingMode, setNumberingMode] = useState<'auto' | 'manual'>('auto');
  const [showNumberingModal, setShowNumberingModal] = useState(false);
  const [tempNumberingMode, setTempNumberingMode] = useState<'auto' | 'manual'>('auto');
  const [restartFiscalYear, setRestartFiscalYear] = useState(false);
  const isInitialMount = React.useRef(true);

  const dispatch: any = useDispatch();
  const {
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    getValues
  } = useFormContext();
  const { formData, formState, updateFormData, updateFormState } =
    useFormData(); // Use the context to access formData and formState

  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);
  const [costCenterOptions, setCostCenterOptions] = useState<SelectOptions[]>(
    []
  );
  const [isOpen, setIsOpen] = useState(false);

  const [approvals, setApprovals] = useState({
    open: false,
    data: [],
  });
  const [isStrictApproval, setIsStrictApproval] = useState<boolean>(false);
  const AllFormDetails = watch();

  const [popUpContent, setPopUpContent] = useState<JSX.Element | null>(null);
  const approvalRequired = watch("approvalRequired");
  const siteIdWatch = watch("site");

  const submitForm = (data: any) => {
    // console.log("setAPPROVAL",approvals);
    console.log("approvalsData", data);
    // if (Object.keys(errors).length === 0) {
    // Get selected siteName and costCenterName
    const selectedSite = sitesOptions.find(
      (option) => option.value === data.site
    );
    const selectedCostCenter = costCenterOptions.find(
      (option) => option.value === data.costCenter
    );
    console.log("data.costCenter", data.costCenter);
    data.endDate = dayjs(data.endDate).format("YYYY-MM-DD");
    data.startDate = dayjs(data.startDate).format("YYYY-MM-DD");
    // Update formData with additional details
    updateFormData("budgetHeader", {
      ...data,
      siteName: selectedSite ? selectedSite.label : "",
      costCenterName:
        data.costCenter !== undefined
          ? selectedCostCenter && selectedCostCenter.label
          : null,
      approvalsData: JSON.stringify(approvals.data),
      isStrictApproval: Boolean(isStrictApproval),
      numberingMode: numberingMode
      // budgetApprovals: data.approvalsData?.map((approval:any) => ({
      //   roleId: approval.roleId,
      //   level: approval.level,
      //   userId: approval.userId,
      //   userName: approval?.userName,
      //   roleName: approval?.roleName,
      // })),

      // requiredDocs: formState.documentData?.documents?.map((doc) => ({
      //   documentName: doc.documentName,
      //   mandatory: doc.mandatory,
      // })),
    });
    setValue("approvalsData", JSON.stringify(approvals));
    setValue("numberingMode", numberingMode);
    if (approvalRequired == "Y" && approvals?.data?.length === 0) {
      return;
    }

    // if (approvalRequired == "Y" && approvals?.data?.length === 0) {
    //   return;
    // }
    console.log("1111", data);
    // return
    // Handle next step navigation here if necessary
    props.next();
    // } else {
    //   console.log("Form Errors:", errors);
    // }
  };

  const showApprovalDrawer = () => {
    updateFormState({ isApprovalDrawerOpen: true });
  };

  const onApprovalClose = () => {
    updateFormState({ isApprovalDrawerOpen: false });
  };

  const handleApprovalData = (data: ApprovalData[]) => {
    updateFormState({
      approvalData: data,
      approvalSubmissionStatus: true,
      approvalPopoverVisible: false,
    });
    onApprovalClose();
  };

  const handleDocumentsSubmit = (data: DocumentFormValues) => {
    updateFormState({ documentData: data, documentsPopoverVisible: false });
    onAskDocumentsClose();
  };

  const showAskDocumentsDrawer = () => {
    updateFormState({ isAskDocumentsDrawerOpen: true });
  };

  const onAskDocumentsClose = () => {
    updateFormState({ isAskDocumentsDrawerOpen: false });
  };

  const fetchSites = async () => {
    try {
      const res = await budgetApis.sitesIdsWithoutBudget();
      if (res?.status) {
        const options = (res?.data || []).map((item: any) => ({
          label: item.siteName,
          value: item.siteId.toString(),
        }));
        setSitesOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCostCenter = async () => {
    try {
      const { data, status } = await costCenterApis.fetchCostCenter();
      if (status) {
        const costCenterOptions = data.map((item: any) => ({
          label: item.costCenterName,
          value: item.id.toString(),
        }));
        setCostCenterOptions(costCenterOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };


  // const fetchAddresses = async () => {
  //   try {
  //     const { data, status } = await deliveryAddressApis.fetchDeliveryAddress();
  //     if (status) {
  //       const addressOptions = data.map((item: any) => ({
  //         label: item.deliveryLocationName,
  //         value: item.id.toString(),
  //       }));
  //       setBillingAddressList(data);
  //       setBillingAddressOptions(addressOptions);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // Clear budget lines when site changes since they depend on site + contractor
  const prevSiteRef = React.useRef(siteIdWatch);
  useEffect(() => {
    if (prevSiteRef.current && siteIdWatch && prevSiteRef.current !== siteIdWatch) {
      updateFormData("materialsData", []);
    }
    prevSiteRef.current = siteIdWatch;
  }, [siteIdWatch]);

  useEffect(() => {
    fetchSites();
    fetchCostCenter();
    if (!getValues("lob")) {
      setValue("lob", "Construction");
    }
    const { approvalsData } = AllFormDetails;
    if (approvalsData) {
      try {
        const parsedData = JSON.parse(approvalsData);
        setApprovals(parsedData);
      } catch (error) {
        console.error("Error parsing approvalsData:", error);
        // If parsing fails, set default structure
        setApprovals({
          open: false,
          data: [],
        });
      }
    }
    if (formData?.budgetHeader?.isStrictApproval !== undefined) {
      setIsStrictApproval(formData.budgetHeader.isStrictApproval);
    }
    // Restore numberingMode from saved budgetHeader when remounting
    if (formData?.budgetHeader?.numberingMode) {
      setNumberingMode(formData.budgetHeader.numberingMode);
    }
  }, []);

  useEffect(() => {
    if (siteIdWatch) {
      fetchSequenceAccess();
    } else {
      setActiveSequences([]);
    }
  }, [siteIdWatch]);

  const fetchSequenceAccess = async () => {
    try {
      const response = await sequenceApis.fetchSequence();
      const { data } = response;
      const today = new Date();
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleName === "Budget" &&
          new Date(item.endDate) > today &&
          item.status === "Active"
      );
      setActiveSequences(_sequenceAccess || []);

      // Check if mode is already persisted (e.g. user navigated back from next step)
      if (formData?.budgetHeader?.numberingMode) {
        setNumberingMode(formData.budgetHeader.numberingMode);
        return;
      }

      // Set initial numbering mode based on available sequences
      if (_sequenceAccess && _sequenceAccess.length > 0 && siteIdWatch) {
        // Check if current site has a sequence
        const siteHasSequence = _sequenceAccess.some(
          (seq: any) => seq.siteId?.toString() === siteIdWatch?.toString() || seq.level === 'Org'
        );
        setNumberingMode(siteHasSequence ? 'auto' : 'manual');
      } else {
        setNumberingMode('manual');
      }
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
      setActiveSequences([]);
      setNumberingMode('manual');
    }
  };

  const getCurrentSiteSequence = () => {
    if (!siteIdWatch || activeSequences.length === 0) return null;

    const siteSequence = activeSequences.find(
      (seq) =>
        seq.level === "Site" &&
        seq.siteId?.toString() === siteIdWatch?.toString()
    );

    if (siteSequence) return siteSequence;

    const orgSequence = activeSequences.find(
      (seq) => seq.level === "Org"
    );

    if (orgSequence) return orgSequence;

    return null;
  };

  const currentSiteSequence = getCurrentSiteSequence();
  const canAuto = !!currentSiteSequence;

  // Auto-generate number when in auto mode
  useEffect(() => {
    const existingValue = getValues("budgetId");

    if (numberingMode === 'auto' && currentSiteSequence && !existingValue) {
      const { prefix } = currentSiteSequence;
      const prNumber = `${prefix}`;
      setValue('budgetId', prNumber);
    }
  }, [numberingMode, currentSiteSequence]);

  // Reset number when site changes (skip initial mount to preserve values on remount)
  useEffect(() => {
    if (isInitialMount.current) {
      return;
    }
    setValue("budgetId", "");
    setNumberingMode("manual");
  }, [siteIdWatch, setValue]);

  // Set initial mode based on site selection (skip initial mount)
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    const prevSite = prevSiteRef.current;

    // Only run if site actually changed
    if (prevSite && prevSite !== siteIdWatch) {
      setValue("budgetId", "");
    }

    // Respect persisted mode on remount
    if (formData?.budgetHeader?.numberingMode) {
      setNumberingMode(formData.budgetHeader.numberingMode);
    } else if (!siteIdWatch) {
      setNumberingMode("manual");
    } else {
      const siteSequence = getCurrentSiteSequence();
      setNumberingMode(siteSequence ? "auto" : "manual");
    }

    prevSiteRef.current = siteIdWatch;
  }, [siteIdWatch]);

  useEffect(() => { }, [dispatch]);

  const startDate = watch("startDate");

  return (
    <>
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <Row className="gy-4">
          <Col lg="4">
            <FormSelect
              name="site"
              label="Select Site"
              options={sitesOptions}
              required={true}
              placeholder="Select site"
            />
          </Col>
          {/* {(sequenceAccess?.level == "Site" &&
            !sequenceAccess?.siteIds?.includes(siteIdWatch)) ||
            sequenceAccess?.module == "" ? (
            <Col lg="4">
              <FormInput
                name="budgetId"
                label={`Budget ID`}
                required={true}
                placeholder="Enter Budget Number"
              />
            </Col>
          ) : (
            <></>
          )} */}

          <Col lg="4">
            <div style={{ position: 'relative' }}>
              <FormInput
                name="budgetId"
                label="Budget ID"
                required={numberingMode === 'manual'}
                disabled={numberingMode === 'auto' || AllFormDetails?.type === "draft"}
                placeholder={numberingMode === 'auto' ? 'Auto-generated' : 'Enter Budget Number'}
              />
              <Tooltip title="Click here to enable or disable auto-generation of Budget numbers.">
                <SettingOutlined
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50px',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '18px',
                    color: '#1890ff',
                    zIndex: 1,
                  }}
                  onClick={() => {
                    setTempNumberingMode(numberingMode);
                    setShowNumberingModal(true);
                  }}
                />
              </Tooltip>
            </div>
          </Col>

          <Col lg="4">
            <FormInput
              name="budgetName"
              label="Budget Name"
              required={true}
              placeholder="Enter Budget Name"
            />
          </Col>
          <Col lg="6">
            <FormDatePicker
              name="startDate"
              label="Planned Start Date"
              required={true}
            />
          </Col>
          <Col lg="6">
            <FormDatePicker
              name="endDate"
              label="Planned End Date"
              required={true}
              minDate={startDate}
              disabled={!startDate}
            />
          </Col>
          <Col lg="12">
            <FormTextArea
              name="description"
              label="Budget Description"
              required={true}
              placeholder="Enter Budget Description"
              maxLength={500}
            />
          </Col>

          <Col lg="3">
            <FormSelect
              name="lob"
              label="Line Of Business (LOB)"
              defaultValue={{
                label: "Construction",
                value: "Construction",
              }}
              options={[
                { label: "Construction", value: "Construction" },
                { label: "Others", value: "Others" },
              ]}
              required={true}
              placeholder="Select LOB"
            />
          </Col>
          <Col lg="3">
            <FormSelect
              name="costCenter"
              label="Cost Center"
              options={costCenterOptions}
              required={false}
              placeholder="Select"
            />
          </Col>
          <Col lg="3">
            <FormSelect
              name="approvalRequired"
              label="Approval Required ?"
              options={[
                { label: "Yes", value: "Y" },
                { label: "No", value: "N" },
              ]}
              placeholder="Select"
              disabled={!siteIdWatch}
              required={true}
            />
            <div style={{ display: "none" }}>
              <FormInput name="approvalsData" label="" type="text" noMaxLength />
            </div>
            {approvalRequired == "Y" && (
              <Popover
                content="Click here to set required approvals"
                title="Approval Required"
              >
                <a
                  href="#"
                  className="success"
                  onClick={(e) => {
                    e.preventDefault();
                    setApprovals((pre) => {
                      return {
                        ...pre,
                        open: true,
                      };
                    });
                  }}
                >
                  <EditOutlined /> Set Approvals &nbsp;
                  {approvals?.data?.length == 0 ? (
                    <span className="mandatory">Please set approvals</span>
                  ) : (
                    <></>
                  )}
                </a>
              </Popover>
            )}
          </Col>
          {/* <Col lg="3">
            <FormSelect
              name="docRequired"
              label="Require Documents?"
              options={[
                { label: "Yes", value: "Y" },
                { label: "No", value: "N" },
              ]}
              required={false}
              placeholder="Select"
              onChange={(val) => updateFormState({ showAskDocs: val === "Y" })}
            /> */}
          {/* {formState.showAskDocs && (
              <Popover
                content="Click here to ask required documents"
                title="Documents Required"
              >
                <a
                  href="#"
                  className="success"
                  onClick={(e) => {
                    e.preventDefault();
                    showAskDocumentsDrawer();
                  }}
                >
                  <EditOutlined /> Ask Required Documents &nbsp;
                  {formState.documentsPopoverVisible ? (
                    <span className="mandatory">Please set documents</span>
                  ) : (
                    <></>
                  )}
                </a>
              </Popover>
            )} */}
          {/* </Col> */}
        </Row>
        <div className="actions clearfix">
          <ul>
            <li>
              <Button color="primary" type="submit">
                Next
              </Button>
            </li>
          </ul>
        </div>
      </form>
      {approvals.open && (
        <BudgetApprovalDrawer
          open={approvals.open}
          siteId={siteIdWatch}
          onClose={() => {
            setApprovals((pre) => {
              return {
                ...pre,
                open: false,
              };
            });
          }}
          onSubmit={(data: any, isStrictApprovalFromDrawer: boolean) => {
            setApprovals({
              open: false,
              data: data,
            });
            setIsStrictApproval(isStrictApprovalFromDrawer);
          }}
          initialStrictApproval={isStrictApproval}
          setApprovalSubmissionStatus={(status: boolean) => { }}
          approvalData={approvals.data} // Pass the current approval data
        />
      )}
      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        className="modal-dialog-centered"
        size="xl"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setIsOpen(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>{popUpContent}</ModalBody>
      </Modal>
      {/* <AskDocuments
        open={formState.isAskDocumentsDrawerOpen}
        onClose={onAskDocumentsClose}
        onSubmit={handleDocumentsSubmit}
        documentData={
          formState.documentData || {
            documents: [
              { documentName: "", description: "", mandatory: false },
            ],
          }
        } // Pass the current document data
      /> */}


      {/* Budget Number Configuration Modal */}
      <AntdModal
        title="Configure Budget Number Preference"
        open={showNumberingModal}
        onCancel={() => setShowNumberingModal(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px" }}>
            <Button
              key="save"
              color="primary"
              onClick={() => {
                if (tempNumberingMode === "auto" && !currentSiteSequence) {
                  message.error("Auto-generation is not configured for this site.");
                  return;
                }

                setNumberingMode(tempNumberingMode);

                if (tempNumberingMode === "auto" && currentSiteSequence) {
                  const { prefix } = currentSiteSequence;
                  const prNumber = `${prefix}`;
                  setValue("budgetId", prNumber);
                }
                else if (tempNumberingMode === "manual") {
                  setValue("budgetId", "");
                }

                setShowNumberingModal(false);
              }}
            >
              Save
            </Button>

            <Button
              key="cancel"
              color="primary"
              onClick={() => setShowNumberingModal(false)}
            >
              Cancel
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: 20, lineHeight: "22px" }}>
          Your Budget numbers are currently set to auto-generate to save time.
          <br />
          Are you sure you want to change this setting?
        </div>

        {!siteIdWatch && (
          <div style={{ color: "#8c8c8c", marginBottom: 16 }}>
            <InfoCircleOutlined /> Sequence configuration is not set for this site. Please configure the sequence.
          </div>
        )}

        {siteIdWatch && !currentSiteSequence && (
          <div style={{ color: "#faad14", marginBottom: 16 }}>
            <InfoCircleOutlined />{" "}
            {activeSequences.length === 0
              ? "No sequences configured for Budgets. Please set up a sequence first."
              : "No sequence configured for the selected site. Please set a sequence for this site."}
          </div>
        )}

        <Radio.Group
          onChange={(e) => setTempNumberingMode(e.target.value)}
          value={tempNumberingMode}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Radio value="auto" disabled={!canAuto}>
              <span style={{ fontWeight: 500 }}>
                Continue auto-generating Budget numbers
              </span>
            </Radio>

            <Radio value="manual">
              <span style={{ fontWeight: 500 }}>
                Enter Budget numbers manually
              </span>
            </Radio>
          </Space>
        </Radio.Group>
      </AntdModal>

    </>
  );
};

export default React.memo(BudgetGeneralDetails);
